import { LicenseSection } from './view';

export default LicenseSection;
